export default "__VITE_ASSET__BUfVptTN__"